import { render } from "./ReportSubTitleItem.vue?vue&type=template&id=0aa609be&scoped=true&ts=true"
import script from "./ReportSubTitleItem.vue?vue&type=script&lang=ts"
export * from "./ReportSubTitleItem.vue?vue&type=script&lang=ts"

import "./ReportSubTitleItem.vue?vue&type=style&index=0&id=0aa609be&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa609be"]])

export default __exports__